import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import React, { useEffect, useRef, useState } from "react";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import Fonts from "../../Resources/Fonts";

import { Feather, MaterialIcons } from "@expo/vector-icons";

import CustomAlert from "../Components/CustomAlert";
import { observer, Observer } from "mobx-react";
import { runInAction } from "mobx";
import PredefinedExercise from "../Firestore/PredefinedExercise";

import { useTranslation } from "react-i18next";

import { useScreenDimensions, useDevice } from "../_layout";
import AddPredefinedExerciseView from "../Exercise/AddPredefinedExerciseView";
import IconEmptyView from "../Components/IconEmptyView";
import { useDrag, useDrop } from "react-dnd";

const PredefinedExerciseLayoutView = observer(
  ({ coach, block, workout, exercise, calendar = false }) => {
    const { t, i18n } = useTranslation();
    const { screenSize } = useScreenDimensions();
    const { isMobile } = useDevice();

    const [showingDeletePredefineds, setShowingDeletePredefineds] =
      useState(false);
    const [showingDeletePredefinedsAlert, setShowingDeletePredefinedsAlert] =
      useState(false);
    const [predefinedToDelete, setPredefinedToDelete] = useState("");
    const deletePredefinedsAlertTitle =
      "deletePredefinedExerciseAlertTitle-string";
    const deletePredefinedsAlertText =
      "¿Estás seguro/a de eliminar el ejercicio predefinido?";
    const [showingAddPredefinedExercise, setShowingAddPredefinedExercise] =
      useState(false);
    const [selectedPredefinedType, setSelectedPredefinedType] = useState("");
    const [showingDeleteProtocolAlert, setShowingDeleteProtocolAlert] =
      useState(false);

    const coachDashboard = block?.isShowingDashboard;

    const getFilteredPredefinedForTypes = (types) => {
      const searchTermLower = coach.searchTermPred
        ? coach.searchTermPred.toLowerCase()
        : "";

      const predefinedArray = coach.customPredefinedExercises || [];

      if (coach.searchTermPred && predefinedArray.length > 0) {
        return predefinedArray.filter((pred) => {
          return (
            t(pred.name).toLowerCase().includes(searchTermLower) &&
            types.includes(pred.type)
          );
        });
      }

      return predefinedArray.filter((pred) => types.includes(pred.type));
    };

    // Function to move exercises within the same type
    const movePredefinedExercise = (
      dragIndex,
      hoverIndex,
      filteredExercises
    ) => {
      runInAction(() => {
        if (dragIndex === hoverIndex) return;

        // Get the dragged exercise and the target exercise
        const draggedExercise = filteredExercises[dragIndex];
        const targetExercise = filteredExercises[hoverIndex];

        if (!draggedExercise || !targetExercise) return;

        // Store original order values before making changes
        const originalOrders = new Map();
        filteredExercises.forEach((exercise, index) => {
          originalOrders.set(exercise.id, exercise.order);
        });

        // Create a new array with the moved exercise
        const newFiltered = [...filteredExercises];
        newFiltered.splice(dragIndex, 1);
        newFiltered.splice(hoverIndex, 0, draggedExercise);

        // Update the order property for all exercises to be consecutive (0, 1, 2, 3...)
        // This ensures no gaps even if the original order values had gaps
        newFiltered.forEach((exercise, index) => {
          const originalIndex = coach.customPredefinedExercises.findIndex(
            (e) => e.id === exercise.id
          );
          if (originalIndex !== -1) {
            const newOrder = index;
            const originalOrder = originalOrders.get(exercise.id);

            // Update the order
            coach.customPredefinedExercises[originalIndex].order = newOrder;

            // Only add to transaction if the order actually changed
            if (originalOrder !== newOrder) {
              coach.updateCoachTransactionExercises(exercise.id);
            }
          }
        });
      });
    };

    const PredefinedExerciseTypeLayoutView = observer(({ type, types }) => {
      const resolvedTypes = types && types.length > 0 ? types : [type];
      const dndKey = type;

      const filtered = getFilteredPredefinedForTypes(resolvedTypes).sort(
        (a, b) => a.order - b.order
      );

      const PredefinedExerciseButton = observer(
        ({ predefinedExercise, index }) => {
          const [isHovered, setIsHovered] = useState(false);
          const ref = useRef(null);

          const isSelected =
            exercise &&
            predefinedExercise.originalName === exercise.originalName &&
            exercise.name !== ""
              ? true
              : false;

          // Drag and Drop setup - only enabled when showingDeletePredefineds is true
          const [{ isOver }, drop] = useDrop({
            accept: `predefined-${dndKey}`,
            drop: (item, monitor) => {
              if (item.index !== index) {
                movePredefinedExercise(item.index, index, filtered);
                coach.startOrResetBatchTimer();
              }
            },
            collect: (monitor) => ({
              isOver: monitor.isOver(),
            }),
          });

          const [{ isDragging }, drag] = useDrag({
            canDrag: showingDeletePredefineds,
            type: `predefined-${dndKey}`,
            item: showingDeletePredefineds
              ? {
                  type: `predefined-${dndKey}`,
                  id: predefinedExercise.id,
                  index,
                }
              : null,
            end: () => {
              if (showingDeletePredefineds) {
                coach.startOrResetBatchTimer();
              }
            },
            collect: (monitor) => ({
              isDragging: monitor.isDragging(),
            }),
          });

          useEffect(() => {
            if (showingDeletePredefineds) {
              drag(drop(ref));
            } else {
              // Disconnect drag and drop when not in delete mode
              drag(null);
              drop(null);
            }
          }, [drag, drop, showingDeletePredefineds]);

          const select = () => {
            if (showingDeletePredefineds) {
              setPredefinedToDelete(predefinedExercise.id);
              setShowingDeletePredefinedsAlert(true);
            } else {
              if (coachDashboard || calendar) {
                if (isSelected) {
                  setShowingDeleteProtocolAlert(true);
                } else {
                  if (exercise) {
                    exercise.setProperty(
                      "originalName",
                      predefinedExercise.originalName
                    );
                    if (exercise.attributes.length === 0) {
                      exercise.setProperty(
                        "name",
                        t(predefinedExercise.originalName)
                      );
                    } else {
                      if (coach) {
                        //SHOULDNT BE NECESSARY
                        coach.selectPredefinedForSlot(exercise, t);
                      }
                    }
                    // exercise.block.updateExercisesNameWithProtocol(exercise);
                  } else {
                    block.addNewSlot(predefinedExercise, t);
                  }
                  coach?.setSearchTermPred("");
                }
              } else {
                const newExercise = predefinedExercise.duplicate(workout, t);
                workout.exercisesToAdd.push(newExercise);
                workout.setSelectedExerciseToAdd(newExercise);
              }
            }
          };

          return (
            <TouchableOpacity
              ref={ref}
              onPress={select}
              style={{ maxWidth: "100%" }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <View
                style={[
                  styles.AttributeButton,
                  {
                    backgroundColor: isHovered
                      ? showingDeletePredefineds
                        ? Colors.redColor
                        : "rgba(63, 123, 141, 0.65)"
                      : isSelected
                      ? Colors.bubbleColor
                      : Colors.whiteColor,
                    borderColor: isHovered
                      ? showingDeletePredefineds
                        ? Colors.redColor
                        : "rgba(63, 123, 141, 0.65)"
                      : isSelected
                      ? Colors.bubbleColor
                      : Colors.grayColor,
                    opacity: isDragging ? 0 : isOver ? 0.4 : 1,
                  },
                ]}
              >
                <View style={[GlobalStyles.HStack, { alignItems: "center" }]}>
                  {showingDeletePredefineds && (
                    <MaterialIcons
                      name="drag-indicator"
                      size={12}
                      color={isHovered ? Colors.whiteColor : Colors.grayColor}
                      style={{
                        marginLeft: 4,
                        marginRight: -2,
                      }}
                    />
                  )}
                  <Text
                    key={index}
                    style={{
                      fontSize: 12,
                      paddingVertical: 5,
                      paddingLeft: 5,
                      paddingRight: showingDeletePredefineds ? 0 : 5,
                      color:
                        isSelected || isHovered
                          ? Colors.whiteColor
                          : Colors.grayColor,
                      width: "100%",
                    }}
                  >
                    {t(predefinedExercise.name)}
                  </Text>
                  {showingDeletePredefineds && (
                    <Feather
                      name="x"
                      size={12}
                      color={isHovered ? Colors.whiteColor : Colors.redColor}
                      style={{ padding: 5 }}
                    />
                  )}
                </View>
              </View>
            </TouchableOpacity>
          );
        }
      );

      const AddPredefinedExerciseButton = ({ title }) => {
        const [isHovered, setIsHovered] = useState(false);
        const action = () => {
          // if (!coach.isOffline) {
          setSelectedPredefinedType(title);
          setShowingAddPredefinedExercise(true);
          // }
        };
        return (
          <TouchableOpacity
            onPress={action}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <View
              style={[
                styles.AttributeButton,
                {
                  backgroundColor: isHovered
                    ? "rgba(63, 123, 141, 0.65)"
                    : Colors.whiteColor,
                  borderColor: isHovered
                    ? "rgba(63, 123, 141, 0.65)"
                    : Colors.grayColor,
                  paddingHorizontal: 2,
                  opacity: 1,
                },
              ]}
            >
              <Text
                style={{
                  fontSize: 12,
                  padding: 5,
                  color: isHovered ? Colors.whiteColor : Colors.grayColor,
                }}
              >
                +
              </Text>
            </View>
          </TouchableOpacity>
        );
      };

      const [isHovered, setIsHovered] = useState(false);

      return (
        (coach.searchTermPred === "" || (filtered && filtered.length > 0)) && (
          <View style={{}}>
            <View style={[GlobalStyles.HStack, {}]}>
              <Text style={Fonts.bold14}>{t(type)}</Text>
              {type === PredefinedExercise.ExerciseTypes.kneeDominant && (
                <>
                  <View style={GlobalStyles.Spacer} />

                  <TouchableOpacity
                    onPress={() => {
                      // if (!coach.isOffline) {
                      setShowingDeletePredefineds(!showingDeletePredefineds);
                      // }
                    }}
                    onMouseEnter={() => !isMobile && setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}
                  >
                    <Feather
                      name="edit-3"
                      size={18}
                      color={
                        showingDeletePredefineds
                          ? Colors.bubbleColor
                          : Colors.grayColor
                      }
                      style={{
                        opacity: isHovered ? 0.5 : 1,
                      }}
                    />
                  </TouchableOpacity>
                </>
              )}
            </View>

            <View style={{ ...styles.AttributeFlex, gap: 6 }}>
              {filtered.map((predefinedExercise, index) => (
                <PredefinedExerciseButton
                  predefinedExercise={predefinedExercise}
                  index={index}
                  key={predefinedExercise.id}
                />
              ))}
              {!showingDeletePredefineds && (
                <AddPredefinedExerciseButton title={type} />
              )}
            </View>
          </View>
        )
      );
    });

    if (!coach.hasMatchingExercises()) {
      return (
        <IconEmptyView
          iconLibrary={"MaterialCommunityIcons"}
          mainText={"emptyExercisesTitle-string"}
          subText={"noExercisesFoundText-string"}
          iconName={"magnify-plus-outline"}
          marginTop={32}
          marginBottom={16}
        />
      );
    }

    return (
      <View
        style={{
          flex: 1,
          gap: 16,
        }}
      >
        <>
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.kneeDominant}
          />

          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.hipDominant}
          />
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.horizontalPush}
          />
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.verticalPush}
          />
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.horizontalPull}
          />
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.verticalPull}
          />
          <PredefinedExerciseTypeLayoutView
            type={PredefinedExercise.ExerciseTypes.other}
            types={[
              PredefinedExercise.ExerciseTypes.other,
              PredefinedExercise.ExerciseTypes.weightlifting,
            ]}
          />
        </>
        {showingDeletePredefinedsAlert && (
          <CustomAlert
            isVisible={showingDeletePredefinedsAlert}
            onClose={() => setShowingDeletePredefinedsAlert(false)}
            title={deletePredefinedsAlertTitle}
            text={deletePredefinedsAlertText}
            action={() => setShowingDeletePredefinedsAlert(false)}
            specialCTA={"delete-string"}
            coach={coach}
            predefinedToDelete={predefinedToDelete}
          />
        )}
        {showingAddPredefinedExercise && selectedPredefinedType !== "" && (
          <AddPredefinedExerciseView
            coach={coach}
            isVisible={showingAddPredefinedExercise}
            onClose={() => setShowingAddPredefinedExercise(false)}
            title={selectedPredefinedType}
            setTitle={() => setSelectedPredefinedType("")}
          />
        )}
        {block && block.selectedSlot && (
          <>
            {block.selectedSlot.workout ? (
              <CustomAlert
                isVisible={showingDeleteProtocolAlert}
                onClose={() => setShowingDeleteProtocolAlert(false)}
                title={t("deleteProtocolAlertTitle-string")}
                text={t("deleteProtocolFromWorkoutAlertText-string", {
                  workoutName: block.selectedSlot.workout.name,
                  itemName: block.selectedSlot.getName(t, i18n.language),
                })}
                action={() => block.deleteExerciseAndSlot(block.selectedSlot)}
                specialCTA={"delete-string"}
              />
            ) : (
              <CustomAlert
                isVisible={showingDeleteProtocolAlert}
                onClose={() => setShowingDeleteProtocolAlert(false)}
                title={t("deleteProtocolAlertTitle-string")}
                text={t("deleteProtocolAlertText-string", {
                  itemName: block.selectedSlot.getName(t, i18n.language),
                })}
                action={() => block.deleteProtocol()}
                specialCTA={"delete-string"}
              />
            )}
          </>
        )}
      </View>
    );
  }
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#EFF4F5",
    paddingTop: 30,
    marginBottom: 20,
  },
  AttributeFlex: {
    flex: 1,
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 8,
    // marginBottom: 16,
  },
  AttributeButton: {
    borderRadius: 8,
    borderWidth: 0.5,
    borderColor: Colors.borderColor,
  },
});

export default PredefinedExerciseLayoutView;
